/* component imports */
import Auth from '../components/auth/Auth';

const AuthPage = () => {
    return <Auth />
}

export default AuthPage;